import axios from 'axios';
import * as types from './types';
import { API_URL_PATHS } from '../../constants/url';
import { getTokenHeader } from '../../helpers/tokenHelper';

const loginUserSuccess = (user) => ({
  type: types.LOGIN_USER_SUCCESS,
  payload: user,
});

const loginUserFail = (errorMessage) => ({
  type: types.LOGIN_USER_FAIL,
  payload: { errorMessage },
});

const verifyTokenStart = () => ({ type: types.VERIFY_TOKEN_START });

const verifyTokenFail = (errorMessage) => ({ type: types.VERIFY_TOKEN_FAIL, payload: {errorMessage} });

const verifyTokenSuccess = (user) => ({
  type: types.VERIFY_TOKEN_SUCCESS,
  payload: user,
});

const resetGlobalAppState = () => ({ type: types.RESET_APP_STATE });

export const loginUser = (email, password) => async dispatch => {
  const credentials = {
    user: { email, password },
  };
  dispatch({ type: types.LOGIN_USER });
  try {
    const res = await axios.post(`${API_URL_PATHS.loginUrl}`, credentials);

    localStorage.setItem('cadess-ui-token', res.data.token);

    dispatch(loginUserSuccess(res.data.user));
  } catch (err) {
    console.log('Login error:', err);

    let errorMessage = {
      title: 'Something went wrong',
      message: 'Please try again',
    };
    if (!err.response) {
      errorMessage = {
        title: 'No contact with server',
        message: 'Check you network or try again later',
      };
    } else if (err.response.status === 401) {
      errorMessage = {
        title: 'Login failed',
        message: 'You have probably entered wrong email or password. Please try again!',
      };
    }

    dispatch(loginUserFail(errorMessage));
  }
};

export const verifyToken = () => async dispatch => {
  dispatch(verifyTokenStart());
  try {
    const { data } = await axios.get(`${API_URL_PATHS.verifyTokenUrl}`, getTokenHeader());
    dispatch(verifyTokenSuccess(data.user));
  } catch (err) {
    const errorMessage = {
      title: 'Authentication failed',
      message: 'You need to login in again',
    };
    localStorage.removeItem('cadess-ui-token');
    dispatch(verifyTokenFail(errorMessage));
  }
};

export const logoutUser = () => dispatch => {
  try {
    axios.get(`${API_URL_PATHS.logoutUrl}`, getTokenHeader());
  } catch (e) {
    console.log('Logout request failed');
  }

  localStorage.removeItem('cadess-ui-token');
  dispatch(resetGlobalAppState());
};
